import { zipObject } from 'es-toolkit';

import quantityUnitFilter from '../filters/quantityUnit';

export default class QuantityUnit {

    static BRUTO = 'BRUTO';
    static NETTO = 'NETTO';

    static options(): Record<string, string> {

        const keys = Object.keys(QuantityUnit);

        return zipObject(keys, keys.map(key => quantityUnitFilter(key)));
    }
}
